module.exports = __webpack_public_path__ + "img/icon-banner-dex-cloud-dark.9626442f.svg";